import { useApp } from '@/context/AppContext';

/**
 * useFeature — check if a plugin/feature is enabled
 *
 * Usage:
 *   const hasAI = useFeature('ai_routing');
 *   if (hasAI) { ... }
 *
 * Or use FeatureGate component for JSX:
 *   <FeatureGate id="ai_routing">
 *     <AIRouteButton />
 *   </FeatureGate>
 */
export function useFeature(id) {
  const { hasPlugin } = useApp();
  return hasPlugin(id);
}

/**
 * FeatureGate — conditionally render children based on plugin state
 *
 * Props:
 *   id       — plugin id (required)
 *   fallback — what to show when feature is off (optional)
 */
export function FeatureGate({ id, children, fallback = null }) {
  const enabled = useFeature(id);
  return enabled ? children : fallback;
}
